export class ApplicantDetails {
    public applicantType:string;
    public selectedCOApplicantIndex: number;
}